import Link from "next/link";
import React from "react";

export default function SubMenuLink({
  href,
  children,
  onClick,
}: Readonly<{
  href: string;
  children: React.ReactNode;
  onClick?: () => void;
}>) {
  return (
    <Link
      href={href}
      onClick={onClick}
      className="block px-8 py-3.5 text-gray-700 hover:bg-gray-100 hover:text-primary transition-colors"
    >
      {children}
    </Link>
  );
}
